module.exports = __webpack_public_path__ + "static/media/icon.ed4aef68.svg";